import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { MarketoCopySource } from 'app/model/pipeline/copysource/marketo.copysource';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(MarketoCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class MarketoCopySourceAdapter extends CopySourceAdapter<MarketoCopySource, Model.MarketoSource> {
    protected override async _toResource(copySource: MarketoCopySource): Promise<Model.MarketoSource> {
        return this._toTabularResource(copySource, Metamodel.modelFor(MarketoCopySource).name);
    }

    protected override async _toModel(
        resource: Model.MarketoSource,
        copyActivity: CopyActivity
    ): Promise<MarketoCopySource> {
        return this._toTabularModel(resource, copyActivity, MarketoCopySource.MODEL);
    }
}
